import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

const CircularProgressBar = () => {
  return (
    <div>
      <CircularProgress size={100} />
    </div>
  );
};

export default CircularProgressBar;